export default __webpack_public_path__ + "static/media/Consumption-fund-card-banner.1a0c6a01.png";